import React, { ReactNode } from "react";

import { Button } from "@/components/atoms/buttons/Button";
import {
  Modal,
  ModalFoot,
  ModalHead,
  Sizes,
} from "@/components/molecules/modals/Modal";

interface Props {
  title: string;
  isOpen: boolean;
  btnText: string;
  disabledConfirm?: boolean;
  handleClose: () => void;
  handleSubmit: () => void | Promise<void>;
  children?: ReactNode;
}

/**
 * 汎用削除確認モーダル
 */
export default function DeleteModal({
  title,
  isOpen,
  handleClose,
  handleSubmit,
  children,
  btnText,
  disabledConfirm
}: Props) {
  return (
    <Modal isOpen={isOpen} handleClose={handleClose} size={Sizes.SS}>
      <ModalHead title={title} onClickClose={handleClose} />

      {children && <div className="p-4">{children}</div>}

      <ModalFoot className="space-x-4">
        <Button
          size="sm"
          spSize="md"
          onClick={handleClose}
          color="cancel"
          label="キャンセル"
        />
        <Button
          size="sm"
          spSize="md"
          color="delete"
          onClick={handleSubmit}
          disabled={disabledConfirm}
          label={btnText}
        />
      </ModalFoot>
    </Modal>
  );
}
